export default __webpack_public_path__ + "static/media/user.2e06c2c3.png";